import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class CardsMenuService {


    itensPai: any[] = [];

    constructor(private httpClient: HttpClient) {
    }


    getIpCliente() {
        return this.httpClient.get('https://json.geoiplookup.io/api?callback=?');
    }

    getIpCliente1() {
        return this.httpClient.get('http://www.geoplugin.net/json.gp?jsoncallback=?');
    }


    getIpCliente2() {
        return this.httpClient.get("http://api.ipify.org/?format=json");
    }


    getIpCliente3() {
        return this.httpClient.get("https://ipapi.co/json/");
    }


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/card-menu/service/cards-menu.service.ts